import { SwabSample } from "../../swab-sample/models/swabSample";
import {SwabByPosition} from "./swabByPosition";

/**
 * @description Swab sample plate that contains up to 96 samples
 */
export class SwabSamplePlate {

    swabsByPosition: SwabByPosition[];  

    constructor() {
        this.swabsByPosition = this.loadPositions();
    }

    /**
     * @description returns an array that is prepared column-wise
     */
    loadPositions() {
        let newSwabsByPosition: SwabByPosition[] = []
        this.loadColumn(newSwabsByPosition, 'A');
        this.loadColumn(newSwabsByPosition, 'B');
        this.loadColumn(newSwabsByPosition, 'C');
        this.loadColumn(newSwabsByPosition, 'D');
        this.loadColumn(newSwabsByPosition, 'E');
        this.loadColumn(newSwabsByPosition, 'F');
        this.loadColumn(newSwabsByPosition, 'G');
        this.loadColumn(newSwabsByPosition, 'H');
        return newSwabsByPosition;
    }

    /**
     * @description loads a swab into the column position
     * @param newSwabsByPosition 
     * @param column 
     */
    loadColumn(newSwabsByPosition: SwabByPosition[] , column) {
        for (var i = 1; i <= 12; i++) {
            let swabByPosition = new SwabByPosition;
            swabByPosition.position = column + i;
            swabByPosition.swab = new SwabSample;
            newSwabsByPosition.push(swabByPosition);
        }
    }

    /**
     * @description adds a swab to a position
     * @param swabSample 
     * @param position 
     */
    addSwabToPosition(swabSample: SwabSample, position: string) {
        let swabPosition: number;
        switch (position.substring(0, 1)) {
            case 'A':
            swabPosition = -1;
            break;
            case 'B':
            swabPosition = 10;
            break;
            case 'C':
            swabPosition = 22;
            break;
            case 'D':
            swabPosition = 34;
            break;
            case 'E':
            swabPosition = 46;
            break;
            case 'F':
            swabPosition = 58;
            break;
            case 'G':
            swabPosition = 70;
            break;
            case 'H':
            swabPosition = 82;
            break;
        }
        swabPosition += parseInt(position.substring(1, 2))
        this.swabsByPosition[swabPosition].swab = swabSample;
    }

}